import './App.css';
import React, { useState, useEffect, useRef } from 'react';
import Nav from './Components/Nav.js';
import Hero from './Components/Hero';
import About from './Components/About.js';
import Projects from './Components/Projects.js';
import Contact from './Components/Contact.js';
import './Resources/OpenSans/OpenSans.ttf'
import Foooter from './Components/Footer.js';
import { useInView } from 'react-intersection-observer';
import Modal from './Components/Modal.js';
import ProjectList from './Resources/Projectlist.jsx';

export default function App() {
  const [mobile, setMobile] = useState(true);
  const [isOpen, setOpen] = useState(false);
  const [proj, setProj] = useState(null);
  const { ref, inView } = useInView();

  const updateView = () => {
    const width = window.innerWidth
    const height = window.innerHeight
    if (width <= height) {
      setMobile(true)
    }
    else setMobile(false)
  }

  useEffect(() => {
    updateView();
    window.addEventListener('resize', updateView)
    if (proj !== null) {
      document.body.style.overflow = 'hidden';
    }
    else {
      document.body.style.overflow = 'auto';
    }
  })

  return (
    <div className="App">
      <Nav $mobile={mobile} isOpen={isOpen} setOpen={setOpen} />
      <Hero $mobile={mobile} />
      <About $mobile={mobile} />
      <Projects $mobile={mobile} proj={proj} setProj={setProj} />
      {proj !== null ?
        <Modal setProj={setProj} $mobile={mobile} proj={proj}>hi</Modal>
        : ""}
      <Contact $mobile={mobile} />
      <Foooter $mobile={mobile} />
    </div>
  );
}